import { Component, JSX } from 'solid-js'
import SimpleModal from './SimpleModal'

interface InappropriateContentModalProps {
  show: boolean
  onClose: () => void
  content?: string
  message?: string
}

const InappropriateContentModal: Component<InappropriateContentModalProps> = (props) => {
  return (
    <SimpleModal show={props.show} onClose={props.onClose}>
      <div class="relative mx-auto flex max-w-md flex-col items-center justify-center rounded-2xl bg-gradient-to-tr from-purple-600 to-blue-600 p-6 shadow-2xl">
        {/* Info Icon */}
        <div class="absolute left-5 top-2 flex items-center">
          <span class="text-xl">ⓘ</span>
        </div>
        {/* Close Button */}
        <button
          class="absolute right-4 top-1 text-4xl text-white hover:opacity-70"
          onClick={props.onClose}
          aria-label="Close"
        >
          ×
        </button>
        {/* Message */}
        <div class="mb-4 mt-5 text-left text-lg leading-snug">
          <div>
            {props.content ? props.content : 'Uh-oh! Your prompt contains inappropriate content.'}
          </div>
          {props.message && (
            <div class="pt-2">{props.message || 'Please try again with a different prompt.'}</div>
          )}
        </div>
        {/* OK Button */}
        <button
          class="w-full rounded-xl border border-white bg-transparent py-3 text-xl font-bold text-white transition hover:bg-white hover:text-[#a259ff]"
          onClick={props.onClose}
        >
          OK
        </button>
      </div>
    </SimpleModal>
  )
}

export default InappropriateContentModal
